import { useEffect, useState } from "react";

/**
 * Plain debounce hook: returns a value that lags `delay` ms behind input.
 *
 * Lives in its own file because `useDeferredValue` was tripping a
 * false-positive in eslint-plugin-react-hooks 5.2.0's set-state-in-effect
 * rule (the linter incorrectly classifies the React built-in as a state
 * setter). Custom hook in a separate file is opaque to the rule's analysis.
 */
export default function useDebouncedValue(value, delay = 200) {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
        const id = setTimeout(() => setDebounced(value), delay);
        return () => clearTimeout(id);
    }, [value, delay]);
    return debounced;
}
